module.exports = __webpack_public_path__ + "static/media/envelop.c68e9ace.svg";